import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { FieldBooksForm } from './field-books.interface';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FieldBooksService {
  private apiUrl = `${environment.apiConfig.uri}/field-book`;

  constructor(private http: HttpClient) { }

  getFieldBookNumber(officeName: string, requestorEmail: string): Observable<any> {
    let params = new HttpParams();
    if(officeName) params = params.set('officeName', officeName);
    if(requestorEmail) params = params.set('requestorEmail', requestorEmail);

    const url = `${this.apiUrl}/getFieldBookNumber`;
    return this.http.get(url, { params });
  }
    
  getFieldBookLogs(requestorEmail: string, officeName: string, startDate: Date, endDate: Date): Observable<any> {
    let params = new HttpParams();
    if(requestorEmail) params = params.set('requestorEmail', requestorEmail);
    if(officeName) params = params.set('officeName', officeName);
    if(startDate) params = params.set('startDate', startDate.toISOString());
    if(endDate) params = params.set('endDate', endDate.toISOString());
    if(officeName) params = params.set('officeName', officeName);

    const url = `${this.apiUrl}/getFieldBookLogs`;
    return this.http.get(url, { params });
  }

}
